import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import 'bootstrap-toggle'
import 'bootstrap-toggle/css/bootstrap-toggle.min.css'

const $ = window.$

export class Toggle extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
  }

  _eventPropagation = true

  constructor (props) {
    super(props)

    this.bootstrapToggle = this.bootstrapToggle.bind(this)
    this.handleRef = this.handleRef.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount () {
    this.bootstrapToggle()
  }

  componentDidUpdate (prevProps, prevState) {
    const { intl, checked, disabled } = this.props

    if (intl !== prevProps.intl) {
      $(this.rootRef).bootstrapToggle('destroy')
      this.bootstrapToggle()
    }

    if (checked !== prevProps.checked) {
      this._eventPropagation = false
      $(this.rootRef).bootstrapToggle(checked ? 'on' : 'off')
      this._eventPropagation = true
    }

    if (disabled !== prevProps.disabled) {
      $(this.rootRef).bootstrapToggle(disabled ? 'disable' : 'enable')
    }
  }

  componentWillUnmount () {
    $(this.rootRef).bootstrapToggle('destroy')
  }

  bootstrapToggle () {
    const { intl } = this.props

    $(this.rootRef).bootstrapToggle({
      on: intl.formatMessage({ id: 'ENABLED' }),
      off: intl.formatMessage({ id: 'DISABLED' })
    })
  }

  handleRef (ref) {
    this.rootRef = ref

    $(this.rootRef).change((event) => {
      this.handleChange(event.target.checked)
    })
  }

  handleChange (newChecked) {
    const { checked, onChange } = this.props

    if (this._eventPropagation && onChange && newChecked !== checked) {
      onChange(newChecked)
    }
  }

  render () {
    const {
      checked,
      disabled
    } = this.props

    return (
      <input
        ref={this.handleRef}
        type='checkbox'
        checked={checked}
        disabled={disabled}
      />
    )
  }
}

export default injectIntl(Toggle)

